import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { saveData, fetchDataFromAPI } from "../components/api.js";
import {
  Container,
  TextField,
  Button,
  Box,
  Typography,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Grid,
  CircularProgress,
} from "@mui/material";
import { Editor } from "@tinymce/tinymce-react";
// Import TinyMCE React component
// import { Editor } from "@tinymce/tinymce-react";
// import dynamic from "next/dynamic";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import config from "../config";
const baseUrl = config.baseURL;
// const Editor = React.lazy(() =>
//   import("@tinymce/tinymce-react").then((module) => ({
//     default: module.Editor ? module.Editor : module.default,
//   }))
// );

const EditPage = () => {
  const { id } = useParams();
  const [pageData, setPageData] = useState({
    title: "",
    description: "",
    type: "",
    sections: [],
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [previewUrls, setPreviewUrls] = useState({});
  useEffect(() => {
    if (id) {
      fetchPageData();
    }
  }, [id]);

  const fetchPageData = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const { data } = await fetchDataFromAPI(`/api/page/${id}`, {}, token);
      setPageData({
        ...data,
        sections: data.sections || [],
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error("Error fetching page data:", err);
    }
  };

  // const handleSave = async () => {
  //   try {
  //     if (id) {
  //       // Edit existing page (PUT request)
  //       await saveData(`/api/page/${id}`, pageData, "PUT");
  //     } else {
  //       // Create new page (POST request)
  //       await saveData(`/api/page`, pageData, "POST");
  //     }
  //     navigate("/dashboard/Pages");
  //   } catch (err) {
  //     console.error("Error saving page data:", err);
  //   }
  // };
  const handleSave = async () => {
    try {
      let pageId = id;

      // ✅ STEP 1: Create or update page (JSON only)
      if (id) {
        await saveData(`/api/page/${id}`, pageData, "PUT");
      } else {
        const cleanPageData = {
          title: pageData.title,
          description: pageData.description,
          type: pageData.type,
        };

        const res = await saveData(`/api/page`, cleanPageData, "POST");

        pageId = res?.id || res?.insertId || res?.data?.id;
      }

      // ✅ STEP 2: Upload sections one by one (WITH IMAGE)
      for (let section of pageData.sections) {
        const formData = new FormData();

        formData.append("page_id", pageId);
        formData.append("title", section.title);
        formData.append("description", section.description);
        formData.append("position", section.position);

        if (section.file) {
          formData.append("textDataPhoto", section.file);
        }

        await fetch(`${baseUrl}/api/page_sections`, {
          method: "POST",
          body: formData,
        });
      }

      navigate("/dashboard/Pages");
    } catch (err) {
      console.error("Error saving page:", err);
    }
  };
  const handleSectionChange = (index, field, value) => {
    const updatedSections = [...pageData.sections];
    updatedSections[index][field] = value;
    setPageData({ ...pageData, sections: updatedSections });
  };

  const handleAddSection = () => {
    const newSection = {
      title: "",
      description: "",
      image_url: "",
      imagePreview: null,
      position: "up", // Default position
      type: "", // Default type
    };
    setPageData({ ...pageData, sections: [...pageData.sections, newSection] });
  };

  // const handleFileChange = (e, index) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const imageUrl = URL.createObjectURL(file);
  //     const updatedSections = [...pageData.sections];
  //     updatedSections[index].image_url = imageUrl;
  //     setPageData({ ...pageData, sections: updatedSections });
  //   }
  // };
  const MAX_FILE_SIZE_MB = 5; // example max size
  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    if (!file) return;

    const updatedSections = [...pageData.sections];

    updatedSections[index].file = file; // 🔥 store file, NOT base64
    updatedSections[index].imagePreview = URL.createObjectURL(file);

    setPageData({ ...pageData, sections: updatedSections });
  };

  const handleEditorChange = (content, index) => {
    const updatedSections = [...pageData.sections];
    updatedSections[index].description = content;
    setPageData({ ...pageData, sections: updatedSections });
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        padding: "20px",
        backgroundColor: "#f4f4f4",
        borderRadius: "8px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Typography variant="h5" sx={{ marginBottom: "20px", color: "#2E4053" }}>
        {id ? `Edit Page: ${pageData.title}` : "Create New Page"}
      </Typography>

      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box>
          <TextField
            label="Title"
            fullWidth
            margin="normal"
            value={pageData.title}
            onChange={(e) =>
              setPageData({ ...pageData, title: e.target.value })
            }
            sx={{ backgroundColor: "#ffffff", borderRadius: "4px" }}
          />

          <Box sx={{ marginBottom: "15px" }}>
            <Typography variant="h6" sx={{ color: "#2E4053" }}>
              Description
            </Typography>
            <Editor
              apiKey="bhhx5owmg4cy7zb3mspn8exvhy9tvrq2ls37ija4vc10wd4p"
              value={pageData.description}
              onEditorChange={(content) =>
                setPageData({ ...pageData, description: content })
              }
              init={{
                height: 300,
                menubar: true,

                plugins: [
                  "advlist",
                  "autolink",
                  "lists",
                  "link",
                  "image",
                  "charmap",
                  "preview",
                  "anchor",
                  "searchreplace",
                  "visualblocks",
                  "code",
                  "fullscreen",
                  "insertdatetime",
                  "media",
                  "table",
                  "help",
                ],

                toolbar:
                  "undo redo | blocks | " +
                  "fontselect fontsizeselect | " +
                  "bold italic underline strikethrough | " +
                  "forecolor backcolor | " +
                  "alignleft aligncenter alignright alignjustify | " +
                  "bullist numlist outdent indent | " +
                  "removeformat | table | code fullscreen | help",

                content_style: `
                  body {
                    font-family: Arial, sans-serif;
                    font-size: 16px;
                    line-height: 1.6;
                    padding: 20px;
                  }
                `,

                font_family_formats:
                  "Arial=arial,helvetica,sans-serif;" +
                  "Georgia=georgia,palatino;" +
                  "Times New Roman=times new roman,times;" +
                  "Courier New=courier new,courier;",

                fontsize_formats: "8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt",
              }}
            />
          </Box>

          {/* Type Selection */}
          <Box sx={{ marginBottom: "15px" }}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Type</InputLabel>
              <Select
                value={pageData.type}
                onChange={(e) =>
                  setPageData({ ...pageData, type: e.target.value })
                }
                label="Type"
              >
                <MenuItem value="career">Career</MenuItem>
                <MenuItem value="pricing">Pricing</MenuItem>
                <MenuItem value="contact_us">Contact Us</MenuItem>
                <MenuItem value="textData">Text Data</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Render Sections if the page type is 'textData' */}
          {pageData.type === "textData" && (
            <Box sx={{ marginTop: "20px" }}>
              <Typography
                variant="h6"
                sx={{ marginBottom: "15px", color: "#2E4053" }}
              >
                Sections
              </Typography>
              {Array.isArray(pageData.sections) &&
              pageData.sections.length > 0 ? (
                pageData.sections.map((section, index) => (
                  <Box
                    key={section.id || index}
                    sx={{
                      padding: "20px",
                      backgroundColor: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      marginBottom: "20px",
                    }}
                  >
                    <Grid container spacing={2}>
                      {/* Section Title */}
                      <Grid item xs={12}>
                        <TextField
                          label="Section Title"
                          fullWidth
                          value={section.title}
                          onChange={(e) =>
                            handleSectionChange(index, "title", e.target.value)
                          }
                          sx={{
                            backgroundColor: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                      </Grid>

                      {/* Section Text Editor */}
                      <Grid item xs={12}>
                        <Typography variant="h6" sx={{ color: "#2E4053" }}>
                          Section Text
                        </Typography>
                        <Editor
                          apiKey="bhhx5owmg4cy7zb3mspn8exvhy9tvrq2ls37ija4vc10wd4p"
                          value={section.description}
                          onEditorChange={(content) =>
                            handleEditorChange(content, index)
                          }
                          init={{
                            height: 300,
                            menubar: true,

                            plugins: [
                              "advlist",
                              "autolink",
                              "lists",
                              "link",
                              "image",
                              "charmap",
                              "preview",
                              "anchor",
                              "searchreplace",
                              "visualblocks",
                              "code",
                              "fullscreen",
                              "insertdatetime",
                              "media",
                              "table",
                              "help",
                            ],

                            toolbar:
                              "undo redo | blocks | " +
                              "fontselect fontsizeselect | " +
                              "bold italic underline strikethrough | " +
                              "forecolor backcolor | " +
                              "alignleft aligncenter alignright alignjustify | " +
                              "bullist numlist outdent indent | " +
                              "removeformat | table | code fullscreen | help",

                            content_style: `
                              body {
                                font-family: Arial, sans-serif;
                                font-size: 16px;
                                line-height: 1.6;
                                padding: 20px;
                              }
                            `,

                            font_family_formats:
                              "Arial=arial,helvetica,sans-serif;" +
                              "Georgia=georgia,palatino;" +
                              "Times New Roman=times new roman,times;" +
                              "Courier New=courier new,courier;",

                            fontsize_formats:
                              "8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt",
                          }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <Button variant="outlined" component="label" fullWidth>
                          Upload Image
                          <input
                            type="file"
                            hidden
                            accept="image/*"
                            onChange={(e) => handleFileChange(e, index)}
                          />
                        </Button>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          label="Image URL"
                          fullWidth
                          value={section.image_url}
                          onChange={(e) =>
                            handleSectionChange(
                              index,
                              "image_url",
                              e.target.value
                            )
                          }
                          sx={{
                            backgroundColor: "#fff",
                            borderRadius: "4px",
                          }}
                        />
                        {section.imagePreview && (
                          <img
                            src={section.imagePreview}
                            alt="Preview"
                            style={{
                              maxWidth: "100%",
                              marginTop: "10px",
                              borderRadius: "4px",
                            }}
                          />
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel>Position</InputLabel>
                          <Select
                            value={section.position}
                            onChange={(e) =>
                              handleSectionChange(
                                index,
                                "position",
                                e.target.value
                              )
                            }
                            label="Position"
                          >
                            <MenuItem value="up">Up</MenuItem>
                            <MenuItem value="down">Down</MenuItem>
                            <MenuItem value="left">Left</MenuItem>
                            <MenuItem value="right">Right</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>
                  </Box>
                ))
              ) : (
                <Typography>No sections available</Typography>
              )}
              <Button
                variant="outlined"
                color="primary"
                fullWidth
                onClick={handleAddSection}
                sx={{
                  marginTop: "20px",
                  backgroundColor: "#2E4053",
                  color: "#fff",
                }}
              >
                Add Section
              </Button>
            </Box>
          )}

          <Button
            variant="contained"
            color="primary"
            fullWidth
            onClick={handleSave}
            sx={{
              marginTop: "20px",
              padding: "12px",
              backgroundColor: "#2E4053",
            }}
          >
            {id ? "Save Changes" : "Create Page"}
          </Button>
        </Box>
      )}
    </Container>
  );
};

export default EditPage;
